
import miniIconMenu from "../components/cms/horizontalMiniIconMenu.vue"
import banner from "../components/cms/banner.vue"
import verticalBannerView from "../components/cms/verticalBannerView.vue"
import brandLogoView from "../components/cms/brandLogoView.vue"
import promotionalView from "../components/cms/promotionalView.vue"
import { getEcomHomeData, getHomeData } from "../api/gateway"
import getCartNumMixin from "@/mixins/getCartNum"
import commonConfig from "@/utils/common"
import ObserverHOC from "@/components/ObserverHOC"
import { trackViewItemList } from "@/utils/track"
import { getHeadLink, getHeadMeta } from "@/utils/head"
import { getRequestHeaders, getLoginStatus, formatProductParamsBy } from "@/utils/utils"
import { Logger } from "@/plugins/logger"
import { getUserIdAndLabel } from "@/utils/userId"
import { handleGetCartDetailV2 } from "@/utils/cartResponse"
const wareTemplete = () => import("../components/cms/wareTemplete.vue")
const fetchData = async context => {
  const { route, req, error, store, app, $cookies } = context
  const shipmentType = 2
  // const shipmentType = $cookies.get("shipmentType")
  const pageType = shipmentType === 2 ? "Banner Home" : "Ecom Home"
  // 自提模式 切换为banner home、默认ecom home
  const getHome = shipmentType === 2 ? getHomeData : getEcomHomeData
  try {
    const { data } = await getHome(
      {
        param: formatProductParamsBy({}, $cookies),
        comm: {}
      },
      {
        loading: true,
        headers: getRequestHeaders({ req, store })
      }
    )
    const lang = store.state.lang
    // 设置门店组
    $cookies.set("storeGroup", data?.data?.storeGroup)
    return {
      pageTitle: data?.titleF?.replace(/^\$/, "") || app.i18n.t("page.title"), // TODO 待调整 按照后端返回的来
      pageType,
      description: app.i18n.t("page.description"),
      homeData: (shipmentType === 2 ? data.cmsConfig : data?.data?.indexConfig) || [],
      lang: lang == "en_US" ? "en" : "zh-hant"
    }
  } catch (err) {
    Logger.error("Banner Home初始化报错", err)
    error({
      statusCode: 500,
      message: "Internal Server Error"
    })
  }
}
export default {
  components: {
    miniIconMenu,
    wareTemplete,
    banner,
    ObserverHOC,
    verticalBannerView,
    brandLogoView,
    promotionalView
  },
  mixins: [getCartNumMixin],
  props: {
    configs: {
      type: Object,
      default: () => {}
    }
  },
  async asyncData(context) {
    const { pageTitle, pageType, description, homeData, lang } = await fetchData(context)
    context.store.commit("setState", { key: "fetched", value: true })
    return {
      pageTitle,
      pageType,
      description,
      homeData,
      lang
    }
  },
  data() {
    return {
      pageTitle: "",
      keyword: "",
      homeData: [],
      isOnline: false,
      cartList: [],
      lang: "",
      pageType: "",
      initialIndex: -1,
      seoPage: true,
      homeBanner: ["711WebHomePageMarqueeBanner1_1"],
      homeIcon: ["711WebHomePageBrandIcon1"],
      bannerReady: false, // 新增
      iconReady: false, // 新增
      firstBannerIndex: -1, // 新增
      firstIconIndex: -1,
      maxRetries: 10, // 最大重试次数
      retryDelay: 2000, // 重试延迟（毫秒）
      retryCount: 0 // 当前重试次数
    }
  },
  head() {
    return {
      title: this.pageTitle,
      meta: [
        { hid: "description", name: "description", content: this.description },
        { name: "og:type", content: "website" },
        { name: "og:title", content: this.pageTitle },
        { name: "og:description", content: this.description },
        { name: "google-site-verification", content: "DEZxSQV2yKcB_MwL4MUiQZqrJNWCz_W9EB8uC6BxPvg" },
        ...getHeadMeta(this)
      ],
      link: getHeadLink(this)
    }
  },

  computed: {},
  created() {},
  async mounted() {
    this.init()
    // 找到第一个 type=19 的索引

    const { isOnline } = getLoginStatus()

    this.isOnline = isOnline
    if (!this.$store.state.fetched) {
      const { pageTitle, pageType, description, homeData, lang } = await fetchData(this.$nuxt.context)
      this.pageTitle = pageTitle
      this.pageType = pageType
      this.description = description
      this.homeData = homeData
      this.lang = lang
      this.initialIndex = 0
    }
    if (isOnline) {
      await handleGetCartDetailV2()
    }

    this.firstBannerIndex = this.homeData.findIndex(item => item.type === 19)
    this.firstIconIndex = this.homeData.findIndex(item => item.type === 75)
    setTimeout(() => {
      this.initSdkWithRetry()
    }, 1000)
  },
  beforeDestroy() {
    this.$bus.$off("getCartSkuList")
  },
  methods: {
    async initSdkWithRetry() {
      try {
        await this.initSdk()
        await this.initIconSdk()
        this.retryCount = 0
      } catch (error) {
        this.retryCount++
        if (this.retryCount < this.maxRetries) {
          setTimeout(() => {
            this.initSdkWithRetry()
          }, this.retryDelay)
        } else {
          this.bannerReady = true
          this.iconReady = true
        }
      }
    },
    async initSdk() {
      try {
        const { userId, customLabel } = getUserIdAndLabel()
        const res = await this.$onlineSalesSdk.fetchDisplayAds({
          cliUbid: userId,
          pageType: "711WebHomePage",
          adUnit: this.homeBanner,
          "f.custom_label_1": customLabel,
          productCount: 10
        })
        const homeBannerList = []
        // 遍历 this.homeBanner 数组，依次处理每个 banner
        this.homeBanner.forEach(bannerName => {
          const bannerArr = res.ads?.[bannerName]
          if (Array.isArray(bannerArr) && bannerArr.length > 0) {
            // 处理每个广告项
            bannerArr.forEach(item => {
              const imageUrl = this.lang == "en" ? item?.elements?.imageEn : item?.elements?.imageTc
              const resourceUrl = this.lang == "en" ? item?.elements?.urlEn : item?.elements?.urlTc
              // 只添加有图片的广告项
              if (imageUrl) {
                homeBannerList.push({
                  spImgUrl: imageUrl,
                  itemType: 19,
                  uclid: item?.uclid,
                  resource: resourceUrl
                })
              }
            })
          }
        })
        const allBanners = this.homeData.filter(item => item.type === 19 && Array.isArray(item.subConfigList))
        if (allBanners.length === 0) {
          this.bannerReady = true
          return
        }
        // 用于跟踪已使用的广告数据索引
        let currentIndex = 0
        // 对每个 type === 19 的 banner 进行处理
        allBanners.forEach(banner => {
          // 判断当前 banner 是否只有占位符
          const onlyPlaceholder =
            Array.isArray(banner.subConfigList) &&
            banner.subConfigList.length > 0 &&
            banner.subConfigList.every(sub => sub.itemType === 30)

          // 找到所有 itemType == 30 的索引
          const itemType30Indices = []
          banner.subConfigList.forEach((item, index) => {
            if (item.itemType === 30) {
              itemType30Indices.push(index)
            }
          })

          // 计算当前 banner 需要的广告数量（占位符数量）
          const placeholderCount = itemType30Indices.length

          // 如果当前 banner 只有占位符且没有足够的新数据，隐藏该 banner
          if (onlyPlaceholder && (currentIndex >= homeBannerList.length || placeholderCount === 0)) {
            this.$set(banner, "hidden", true)
            return
          }

          // 否则显示该 banner 并进行数据替换
          this.$set(banner, "hidden", false)

          // 只有当存在 itemType == 30 的数据时才进行操作
          if (itemType30Indices.length > 0) {
            // 计算当前 banner 可用的广告数量
            const availableCount = homeBannerList.length - currentIndex
            const replaceCount = Math.min(placeholderCount, availableCount)

            // 替换占位符
            for (let i = 0; i < replaceCount; i++) {
              const originalIndex = itemType30Indices[i]
              const adIndex = currentIndex + i
              banner.subConfigList[originalIndex] = homeBannerList[adIndex]
            }

            // 如果新数据不够，删除多余的占位符（从后往前删除，避免索引变化）
            if (replaceCount < placeholderCount) {
              const indicesToRemove = itemType30Indices.slice(replaceCount).reverse()
              indicesToRemove.forEach(index => {
                banner.subConfigList.splice(index, 1)
              })
            }

            // 更新已使用的广告数据索引
            currentIndex += replaceCount
          }
        })
        this.bannerReady = true
      } catch {
        this.bannerReady = true // 数据准备好
      }
    },
    async initIconSdk() {
      try {
        const { userId, customLabel } = getUserIdAndLabel()
        const res = await this.$onlineSalesSdk.fetchDisplayAds({
          cliUbid: userId,
          pageType: "711WebHomePage",
          adUnit: this.homeIcon,
          "f.custom_label_1": customLabel,
          productCount: 10
        })
        const homeIconList = []
        // 遍历 this.homeIcon 数组，依次处理每个 icon
        this.homeIcon.forEach(iconName => {
          const iconArr = res.ads?.[iconName]
          if (Array.isArray(iconArr) && iconArr.length > 0) {
            // 处理每个广告项
            iconArr.forEach(item => {
              const imageUrl = this.lang == "en" ? item?.elements?.imageEn : item?.elements?.imageTc
              const resourceUrl = this.lang == "en" ? item?.elements?.urlEn : item?.elements?.urlTc
              const remark = this.lang == "en" ? item?.elements?.headlineEn : item?.elements?.headlineTc
              // 只添加有图片的广告项
              if (imageUrl) {
                homeIconList.push({
                  spImgUrl: imageUrl,
                  itemType: 75,
                  remark,
                  uclid: item?.uclid,
                  resource: resourceUrl
                })
              }
            })
          }
        })
        const firstIcon = this.homeData.find(item => item.type === 75 && Array.isArray(item.subConfigList))
        const onlyPlaceholder =
          firstIcon &&
          Array.isArray(firstIcon.subConfigList) &&
          firstIcon.subConfigList.length > 0 &&
          firstIcon.subConfigList.every(sub => sub.itemType === 30)
        if (firstIcon && homeIconList.length === 0 && onlyPlaceholder) {
          this.$set(firstIcon, "hidden", true)
          this.iconReady = true
          return
        }
        if (firstIcon) {
          // 找到所有 itemType == 30 的索引
          const itemType30Indices = []
          firstIcon.subConfigList.forEach((item, index) => {
            if (item.itemType === 30) {
              itemType30Indices.push(index)
            }
          })
          // 只有当存在 itemType == 30 的数据时才进行操作
          if (itemType30Indices.length > 0) {
            // 逐个替换，保持原有顺序
            itemType30Indices.forEach((originalIndex, replaceIndex) => {
              if (replaceIndex < homeIconList.length) {
                // 直接替换对应位置的数据
                firstIcon.subConfigList[originalIndex] = homeIconList[replaceIndex]
              } else {
                // 如果新数据不够，删除多余的占位符
                firstIcon.subConfigList.splice(originalIndex, 1)
                // 调整后续索引
                for (let i = replaceIndex + 1; i < itemType30Indices.length; i++) {
                  itemType30Indices[i]--
                }
              }
            })
          }
        }
        this.iconReady = true
      } catch {
        this.iconReady = true // 数据准备好
      }
    },
    init() {
      // 组装已加购数据
      this.$bus.$on("getCartSkuList", val => {
        this.cartList = val
        const selWares = {}
        this.cartList.forEach(item => {
          selWares[item.sku] = { count: item.count, stock: item.stock, remainingMaxCount: item.remainingMaxCount }
        })
        this.homeData.forEach(cmsItem => {
          if (cmsItem.type == 26) {
            cmsItem.subConfigList.forEach(ware => {
              if (selWares[ware?.additional?.sku]) {
                this.$set(ware, "addCartCount", selWares[ware.additional.sku].count)
                this.$set(ware, "stock", selWares[ware.additional.sku].stock)
                this.$set(ware, "remainingMaxCount", selWares[ware.additional.sku].remainingMaxCount)
              } else {
                this.$set(ware, "addCartCount", 0)
              }
            })
          }
          return cmsItem
        })
      })
    },
    handleVisibility(index) {
      trackViewItemList(this.homeData[index].subConfigList)
    }
  }
}
